import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, PageSlotModule } from '@spartacus/storefront';
import { GenCategoryNavigationModule } from '../../category-navigation/category-navigation.module';
import { GenLoginComponent } from './login.component';
import { GenLoadingSpinnerComponent } from 'src/app/generac/shared/components/loading-spinner/loading-spinner.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    PageSlotModule,
    I18nModule,
    FormErrorsModule,
    GenCategoryNavigationModule,
    GenLoadingSpinnerComponent,
  ],
  declarations: [GenLoginComponent],
})
export class GenLoginModule {}
